import React, { KeyboardEventHandler, PureComponent, ReactNode } from "react";

interface Props {
    type: string
    label: string
    error: boolean
    value: string | number | undefined
    raiseUpdates: (fileName: string) => void
    maxLength?: number,
    numberOfLines?: number
    className?: string
    onKeyDown?: KeyboardEventHandler
    onBlur?: () =>void;
    disabled?: boolean;
    placeholder?: string;
}

export class TextInput extends PureComponent<Props> {
    render(): ReactNode {
        const className = this.props.error ? 'error' : ''
        const classNameContainer = this.props.className ? this.props.className + ' wizard-form-input' : 'wizard-form-input'
        const isDisabled = this.props.disabled ? ' disabled' : ''

        return (
            <div className={classNameContainer + isDisabled}>
                <label>{this.props.label}</label>
                {this.props.numberOfLines ?
                    <textarea rows={this.props.numberOfLines}
                              value={this.props.value ?? ''}
                              className={className}
                              onBlur={this.props.onBlur}
                              onChange={(event) => this.props.raiseUpdates(event.target.value)}>{this.props.value}</textarea>
                    :
                    <input type={this.props.type}
                           disabled={!!this.props.disabled}
                           maxLength={this.props.maxLength}
                           value={this.props.value ?? ''}
                           className={className}
                           placeholder={this.props.placeholder ?? ''}
                           onBlur={this.props.onBlur}
                           onKeyDown={this.props.onKeyDown}
                           onChange={(event) => this.props.raiseUpdates(event.target.value)}/>
                }

            </div>
        )
    }
}
